module.exports = __webpack_public_path__ + "img/1_Dicks_Screen_1_R.d6c9349d.jpg";